import React from 'react';
import { Link } from 'react-router-dom';
import { nitrologo } from '../utilities/images';

const AuthNavbar = () => (
  <nav style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "20px 5%", borderBottom: '1px solid #eee' }}>
    <Link to="/">
      <img src={nitrologo} alt="9troRide Logo" style={{ height: "40px", objectFit: "contain" }} />
    </Link>
  </nav>
);

export default AuthNavbar;